import moment from "moment";

const ArrayOfYears = (start) => {
  const currentMonth = moment().month();
  const currentWeek = parseInt(moment().format("W"));

  let current = new Date().getFullYear();
  if (currentWeek === 1 && currentMonth === 11) current++;

  const array = [];
  for (let i = current; i >= start; i--) {
    array.push(i);
  }
  return array;
};

export default ArrayOfYears;
